<div
  fxLayout="row"
  class="header-section-wrapper"
  [ngClass]="{ 'header-section-meta': isMetaRoute }">
  <!-- <div class="start-section" fxLayout="column" fxLayoutAlign="start center">
      <i class="icon-arrow-dir-left icon-active margin-1 cursor-pointer" (click)="goBack()"></i>
      <p class="font-light font-xs sparro-grey-900 margin-0" style="margin:4px 0; text-align: center;">Back</p>
  </div> -->
  <div
    class="middle-section"
    fxLayout="column"
    fxLayout.gt-md="row"
    fxLayoutGap="8px"
    fxLayout.lt-md="row"
    fxLayout.lt-sm="column">
    <!-- <p class="margin-0 font-xs sparro-grey-900"> Journal Editor </p> -->
    <div class="icons-group" fxLayout="row" fxLayoutGap="8px">
      <!-- <div fxLayout="row" class="icon">
        <i class="icon-character"></i>
        <span class="sparro-grey-900 font-xs header-icon">{{ wordCount }}</span>
      </div> -->
      <!-- <div fxLayout="row" class="icon">
        <i class="icon-image-bold"></i>
        <span class="sparro-grey-900 font-xs header-icon"> {{ imageCount }}</span>
      </div>
      <div fxLayout="row" class="icon">
        <i class="icon-embed-video-bold"></i>
        <span class="sparro-grey-900 font-xs header-icon"> {{ embedCount }}</span>
      </div> -->
    </div>
  </div>

  <div fxHide.gt-sm class="flex-container">
    <uni-navigation-button
      style="cursor: pointer"
      default="Next"
      (click)="onClickNext()"
      [disabled]="!next"
      *ngIf="!isMetaRoute"
      button_class="primary">
    </uni-navigation-button>
    <uni-navigation-button
      style="cursor: pointer"
      default="Publish"
      (click)="publishBlog()"
      [disabled]="!canPublish"
      *ngIf="isMetaRoute"
      button_class="primary">
    </uni-navigation-button>
    <!-- <div *ngIf="!isMetaRoute">
      <span class="sparro-grey-500 font-xs"> {{ lastSaved }} </span>
    </div> -->
  </div>

  <div
    fxHide.lt-md
    class="end-section"
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="8px">
    <!-- <div *ngIf="!isMetaRoute">
      <span class="sparro-grey-500 font-xs"> {{ lastSaved }} </span>
    </div> -->
    <uni-navigation-button
      style="cursor: pointer"
      default="Next"
      (click)="onClickNext()"
      [disabled]="!next"
      *ngIf="!isMetaRoute"
      button_class="primary"
      matTooltip="Please add the title, description, and content of the journal to add tags."
      matTooltipPosition="below"
      [matTooltipDisabled]="next"
      customClass="margin-0">
    </uni-navigation-button>
    <uni-navigation-button
      style="cursor: pointer"
      default="Publish"
      (click)="publishBlog()"
      [disabled]="!canPublish"
      *ngIf="isMetaRoute"
      button_class="primary"
      customClass="margin-0">
    </uni-navigation-button>
  </div>
</div>
